// The Closing tab's step rules that the server's Overview count repeats. Each is
// pinned to its C# copy by a shared fixture in tests/fixtures/.

export const STEP1_CERTS = [
  "Close.S1.UnderwritingSignedOff",
  "Close.S1.FinalAddendumSigned",
  "Close.S1.EscrowFundedByBuyer",
  "Close.S1.LoanDocumentsSigned",
];

// Closing Step 1 is complete when each of the four certifications has a
// Certified row (owner ruling 3, 2026-10-08). A Pending row (opening the form
// and saving creates one), a Declined or an Escalated one leaves it incomplete.
// Server copy: ClosingStepOneCompletion.IsComplete (the Overview, Q11);
// fixture: closing-step1-certification-cases.json.
export function isStepOneComplete(
  rows: readonly { certificationCode: string; status: string }[],
): boolean {
  const certified = new Set(rows.filter((r) => r.status === "Certified").map((r) => r.certificationCode));
  return STEP1_CERTS.every((code) => certified.has(code));
}

// Closing Step 2 (Payment Setup Status) is complete when the deal has at least
// one party and every party's setup status is "complete" (owner ruling 20,
// 2026-10-08). Status only: it gates nothing. Server copy:
// PaymentSetupCompletion.IsComplete (the Overview); fixture:
// closing-step2-payment-setup-cases.json.

export function isPaymentSetupComplete(parties: readonly { setupStatus: string }[]): boolean {
  return parties.length > 0 && parties.every((p) => p.setupStatus === "complete");
}
